export const whatProblemData = {
  title: 'What problems did you experience with the work on your property?',
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/3b77a800c8c0-tooliconwarning.jpg',
    alt: '',
  },
  note: [''],
  descriptiveText: [
    'In a few words, please tell us how the work did not fulfil what they promised and therefore breached their contract with you, the buyer. What you write here will appear in the final letter of claim, so please be as clear as possible, including dates.',
  ],
  placeholderText: '',
}
